import { render, staticRenderFns } from "./ListEvents.vue?vue&type=template&id=5c80325d&"
import script from "./ListEvents.vue?vue&type=script&lang=js&"
export * from "./ListEvents.vue?vue&type=script&lang=js&"
import style0 from "./ListEvents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports